import cloudinary from "cloudinary-core";
import VideoPlayer from "cloudinary-video-player";

export default {
  name: "video-cloud",

  ui: {
    video: "[js-cloud-video]"
  },

  componentDidMount() {
    var cld = cloudinary.Cloudinary.new({
      cloud_name: config.cloudinary.options.cloud_name
    });
    var videoId = this.ui.video.getAttribute("id"); //this.ui.video.dataset.cldPublicId.split('/')
    //videoId = `video-${videoId}`
    //console.log(videoId)
    //videoId = videoId}

    var player = cld.videoPlayer(videoId, {
      controls: true,
      fluid: true,
      sourceTypes: ["mp4", "webm", "ogv"]
    });
  }
};
